import {
  SET_WOMEN_FORM_FIELD, SET_WOMEN_ADDRESS_CONFIRMED,
  SET_WOMEN_ADDRESS_FIELD, WOMEN_RESET,
  WOMEN_SET_COMPLETE_STATE
} from '@/utils/store/mutationTypes'
import { defaultState } from '@/enums/womenSignup'

export default {
  /**
   * Sets a field in the women signup form.
   *
   * @param state
   * @param key
   * @param value
   */
  [SET_WOMEN_FORM_FIELD] (state, { key, value }) {
    state.form[key] = value
  },
  [SET_WOMEN_ADDRESS_CONFIRMED] (state, addressConfirmed = true) {
    state.addressConfirmed = addressConfirmed
  },
  [SET_WOMEN_ADDRESS_FIELD] (state, { key, value }) {
    state.form.address[key] = value
  },
  [WOMEN_RESET] (state) {
    state.addressConfirmed = defaultState.addressConfirmed

    state.form = { ...defaultState.form }
  },
  [WOMEN_SET_COMPLETE_STATE] (state, newState) {
    state.addressConfirmed = newState.addressConfirmed

    state.form = { ...newState.form }
  }
}
